import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { Copil } from '@apps/pata/domain/models/copil';

export const BackPataCopilFeatureKey = 'copils';

type ICopilState = EntityState<Copil>;
export const copilsAdapter: EntityAdapter<Copil> = createEntityAdapter({
    selectId: (copil: Copil) => copil.copilId
});
const copilsInitialState: ICopilState = copilsAdapter.getInitialState({});

export interface IBackPataCopilsState {
    copils: ICopilState;
    isLoading: boolean;
    isLoaded: boolean;
    isEmpty: boolean;
    isOups: boolean;
    planifiedFilter?: boolean;
    qsWord: string;
}

export const BackPataCopilsInitialState: IBackPataCopilsState = {
    copils: copilsInitialState,
    isLoading: false,
    isLoaded: false,
    isEmpty: false,
    isOups: false,
    planifiedFilter: null,
    qsWord: ''
};
